var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"rwt-gallery-area rn-section-gapBottom"},[_c('div',{staticClass:"container"},[_c('Gallery',{attrs:{"gallery-data":_vm.galleryData,"column":"col-lg-2 col-md-6 col-sm-6 col-12 mt--30"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }